/**
 * Labstep
 *
 * @module components/ResourceLocation/Manager
 * @desc Manager of resource sub locations
 */

import { ResourceLocationActionCreateSub } from 'labstep-web/components/ResourceLocation/Action/CreateSub';
import ResourceLocationSearch from 'labstep-web/components/ResourceLocation/Search';
import type React from 'react';
import type { IResourceLocationManagerProps } from './types';

export const ResourceLocationManager: React.FC<
  IResourceLocationManagerProps
> = ({ resourceLocation }) => (
  <ResourceLocationSearch
    action={
      <ResourceLocationActionCreateSub
        resourceLocation={resourceLocation}
      />
    }
    outerResourceLocation={resourceLocation}
  />
);
